import jquery from 'jquery';
import $ from 'jquery';
import gsap from 'gsap';

import Slideshow from './slideshow';

import { btnFade } from './utils';

class About {
    constructor () {
        this.hover = {
            in() {
                if (!$('#about-btn').hasClass('about-clicked')) {
                    gsap.fromTo('#about-page', 0.4, {
                        yPercent: 100,
                    },{
                        yPercent: 99,
                        display: 'block',
                        visibility: 'visible',
                        ease: Power3.easeInOut
                    });
                }
            },
            out() {
                if (!$('#about-btn').hasClass('about-clicked')) {
                    gsap.to($('#about-page'), 0.4, {
                        yPercent: 100,
                        ease: Power3.easeInOut
                    });
                }
            }
        }
    }

    init() {

        this.bindEvents();

    }

    bindEvents() {

        $('#about-btn').hover(() => {
            console.log('in');
            this.hover.in();
        },()=> { this.hover.out() });

        $('#about-btn').off('click').on('click', this.openPage);

        $('#about-btn-close').off('click').on('click', this.closePage);

    }

    openPage() {

        $('#about-btn').addClass('about-clicked');

        gsap.to('#about-page', 1, {
            yPercent: 0,
            ease: Power3.easeInOut
        });

        $('#about-cont-page').load('about.html');

        gsap.set('#about-cont-page', {
            yPercent: 15
        });
        gsap.to('#about-cont-page', 0.6, {
            yPercent: 0,
            opacity: 1,
            ease: Power3.easeInOut,
            delay: 0.7
        });

        gsap.to($('#about-btn-close'), 0.6, {
            opacity: 1,
            ease: Power3.easeInOut,
            delay: 0.6
        });

    }

    closePage() {

        gsap.to('#about-page', 1, {
            yPercent: 100,
            ease: Power3.easeInOut,
            onComplete: () => {
                $('#about-btn').removeClass('about-clicked');
            }
        });

        gsap.to('#about-cont-page', 0.6, {
            clearProps: 'all',
            ease: Power3.easeInOut
        });

        gsap.to('#about-btn-close', 0.3, {
            opacity: 0,
            ease: Power3.easeInOut
        });

    }

}

export default About;



/** WEBPACK FOOTER **
 ** ./components/about.js
 **/